module.exports = __webpack_public_path__ + "img/G1.6cbb04e0.png";